<template>
    <div id="ReviewDetails">
        <div class="content-container text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
            <h3 class="pb-5 brand-text align-self-center">{{title}}</h3>
            <p class="pb-5 text-center">{{subtitle}}</p>
            <div class="details-container">
                <div class="details-row" v-for="(item, i) in items">
                    <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                        <div class="details-row-title">{{ item.text ? item.text : item.title}}</div><span class="edit-button brand-primary align-self-start" @click="previousQuestion(item.id)">Edit</span>
                    </div>
                    <div v-for="(i, k) in item.items">
                        <div v-if="i.type !== 'file'">{{i.value}}</div>
                        <div v-else>
                            <img class="img-fluid preview-image mr-3 mt-3" v-if="!i.value.length > 1" :src="i.value" />
                            <img class="img-fluid preview-image mr-3 mt-3" v-for="url in i.value" v-else :src="url" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import config from "../../config/constants";

export default {
	components: {

	},
	name: "ReviewDetails",
	data() {
		return {
            items: [],
		};
	},
	mounted() {
        this.getUserCollection();
	},
	beforeDestroy() {
	
	},
	methods: {
        async getUserCollection() {
            let res = await axios.get(
                config.matchtech_api_env + "/quiz/user-collection",
                this.matchTechOptions
            );
            if (res.data) {
                this.questionLoaded = true;
                this.items = res.data.answers;
                this.currentQuestion = res.data.question;
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
	},
    computed: {
        matchTechOptions() {
            return this.getMatchTechOptions();
        },
    },
	props : ['data', 'previousQuestion', 'title', 'subtitle'],
};
</script>
<style lang="less">
#ReviewDetails{
    .text-prompt-container {
        max-width: 700px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }

        .details-container{
            width: 100%;
            background-color: white;
            border: 1px solid #dde1e6;
            .details-row{
                border-bottom: 1px solid #dde1e6;
                padding: 20px;
                word-wrap: break-word;
                .details-row-title{
                    font-weight: 500;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
                .edit-button{
                    cursor: pointer;
                    font-weight: bold;
                }
            }
        }
    }
    .preview-image {
        max-width: 150px;
        min-width: 150px;
        min-height: 150px;
        max-height: 150px;
        object-fit: scale-down;
        border-radius: 16px;
        border: 1px solid #ccc;
        background-color: white;
    }

}
</style>